import BaseService from './BaseService';

class CustomerService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/provider/getCustomerConfiguration?providerCode=";
	}

  getCustomerConfiguration() {
		const url = this.serviceUrl + "/getCustomerConfiguration?providerCode=" + provider;
		return this.opencellAPI.callApi(url);
	}

	getCustomerAccountConfiguration() {
		const url = this.serviceUrl + "/getCustomerAccountConfiguration?providerCode=" + provider;
		return this.opencellAPI.callApi(url);
	}

	updateCustomer(customer) {
		const url = "/api/rest/account/customer";
		return  this.opencellAPI.invokeRequest(customer, url, "PUT");
	}

	findCustomerDirect(customer) {
		const url = "/api/rest/v2/generic/all/customer";
		return  this.opencellAPI.invokeRequest(customer, url, "POST");
	}

	findContactInfo(params) {
		const url = "/api/rest/v2/generic/all/contact";
		return  this.opencellAPI.invokeRequest(params, url, "POST");
	}

	getCountryList() {
		const url = "/api/rest/countryIso/list";
		return this.opencellAPI.callApi(url);
	}

	findCustomer(customerCode) {
		return this.opencellAPI.find_customer(customerCode);
	}



}

const customerService = new CustomerService();

export default customerService;



// WEBPACK FOOTER //
// ./src/opencell/services/CustomerService.js